import { atom } from "jotai";

import { UpdateEmailOrPhoneProfileStepState } from "../types";

export const defaultUpdateEmailOrPhoneProfileStepState: UpdateEmailOrPhoneProfileStepState =
  {
    step: "Initial",
    backStep: null,
  };

export const UpdateEmailOrPhoneProfileStepStateAtom =
  atom<UpdateEmailOrPhoneProfileStepState>(
    defaultUpdateEmailOrPhoneProfileStepState
  );

export const UpdateEmailOrPhoneProfileCloseActionAtom = atom<
  (() => void) | null
>(null);
export const UpdateEmailOrPhoneProfileCompleteActionAtom = atom<
  (() => void) | null
>(null);
